<sharry-header></sharry-header>
<div class="ambassador">
  <div class="ambassador__title">
    <img
      height="48"
      width="48"
      [alt]="'Pro-gold'"
      [src]="'https://media.sharry.land/app/images/ambassador/img-diventa-ambassador.webp'" />
    <h1 [innerHTML]="'ambassador.title' | i18next"></h1>
    <div class="divider"></div>
    <p>{{ 'ambassador.subtitle' | i18next }}</p>
  </div>
  <div class="ambassador__who-are">
    <div
      class="ambassador__who-are__img is-not-mobile"
      [style.background-image]="'url(https://media.sharry.land/app/images/ambassador/hero-ambassador.webp)'"></div>
    <div
      class="ambassador__who-are__img is-mobile"
      [style.background-image]="
        'url(https://media.sharry.land/app/images/ambassador/hero-ambassador-mobile.webp)'
      "></div>
    <h2>
      {{ 'ambassador.who-are' | i18next }}
    </h2>
    <p
      class="ambassador__who-are__description"
      [innerHTML]="'ambassador.description' | i18next"></p>
  </div>
  <div class="ambassador__what-do">
    <h2>
      {{ 'ambassador.what-do' | i18next }}
    </h2>
    <div class="ambassador__what-do__grid">
      @for (item of list; track item) {
        <div class="ambassador__what-do__grid__list">
          <img
            alt=""
            width="48px"
            height="48px"
            [src]="item.icon" />
          <h3>
            {{ item.title | i18next }}
          </h3>
          <p>
            {{ item.subtitle | i18next }}
          </p>
        </div>
      }
    </div>
  </div>
  <div class="ambassador__how-to-become">
    <h2 [innerHTML]="'ambassador.how-to-become.title' | i18next"></h2>
    <div class="divider"></div>
    <p>{{ 'ambassador.how-to-become.subtitle' | i18next }}</p>
    <div class="ambassador__how-to-become__quantity">
      <span class="semibold cursor-pointer touchable"> {{ 'ambassador.how-to-become.quantity' | i18next }}&nbsp; </span>
      <img
        width="50"
        height="50"
        alt="ciliegia"
        [src]="'https://media.sharry.land/app/images/ciliegiometro/icona-ciliegiometro.webp'" />
    </div>
  </div>
  <div class="ambassador__how-to-collect">
    <h2 [innerHTML]="'ambassador.how-to-collect.title' | i18next"></h2>
    <div class="divider"></div>
    <p>{{ 'ambassador.how-to-collect.subtitle' | i18next }}</p>
    <div class="ambassador__how-to-collect__list">
      <div>
        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.follow' | i18next }}</span>
          <sharry-icon
            registryName="user-circle"
            svgClass="svg-icon"></sharry-icon>
        </div>

        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.like' | i18next }}</span>
          <sharry-icon
            name="clapping"
            type="custom"
            svgClass="svg-icon"></sharry-icon>
        </div>

        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.comment' | i18next }}</span>
          <sharry-icon
            name="chat-circle"
            svgClass="svg-icon"></sharry-icon>
        </div>
      </div>
      <div>
        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.share' | i18next }}</span>
          <sharry-icon
            name="share-network"
            svgClass="svg-icon"></sharry-icon>
        </div>

        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.collection' | i18next }}</span>
          <sharry-icon
            registryName="bookmark-simple"
            svgClass="svg-icon"></sharry-icon>
        </div>

        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.advise' | i18next }}</span>
          <sharry-icon
            registryName="star"
            svgClass="svg-icon"></sharry-icon>
        </div>

        <div class="ambassador__how-to-collect__list--element">
          <span>{{ 'ambassador.how-to-collect.quiz' | i18next }}</span>
          <sharry-icon
            name="trophy"
            svgClass="svg-icon"></sharry-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="ambassador__benefits">
    <h2 [innerHTML]="'ambassador.benefits.title' | i18next"></h2>
    <div class="divider"></div>
    @for (benefit of benefits; track benefit) {
      <div class="ambassador__benefits__list">
        <div>
          <p class="ambassador__benefits__list--title semibold">{{ benefit.title | i18next }}</p>
          <p class="ambassador__benefits__list--subtitle">{{ benefit.subtitle | i18next }}</p>
        </div>
      </div>
    }
  </div>
  <div class="ambassador__local-ambassadors">
    <h2 [innerHTML]="'ambassador.local-ambassadors.title' | i18next"></h2>
    <div class="divider"></div>
    @if (ambassadors$ | async; as ambassadors) {
      <sharry-card-carousel
        [usePagination]="true"
        [contents]="ambassadors"
        [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
    }
  </div>
  <div class="ambassador__footer">
    <h2 [innerHTML]="'ambassador.footer.title' | i18next"></h2>
    <a
      class="sharry-big"
      mat-flat-button
      color="primary"
      [routerLink]="['sharry' | routeTranslate, 'webinar-diventa-ambassador']">
      {{ 'ambassador.footer.button' | i18next }}
    </a>
  </div>
</div>
<sharry-footer class="is-not-mobile"></sharry-footer>
